import { OFFER_FRAGMENT } from '../../fragments/offer';

const GET_COMMENTS_BY_NICKNAME_QUERY = `
  query GetCommentsByNicknameQuery($commentsAfter: String, $nickname: String!) {
    public {
      userByNickname(nickname: $nickname) {
        comments(limit: 10, after: $commentsAfter) {
          edges {
            id
            content
            timestamps {
              createdAt
            }
            offer {
              ...OfferFragment
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
  ${OFFER_FRAGMENT}
`;

export default GET_COMMENTS_BY_NICKNAME_QUERY;
